export const ASSETS_EXT_ORIGIN = 'https://assets-ext.bizzabo.com';
export const BIZZABO_CLOUDS = ['bizzaboprod', 'bizzabo-demo'];

const clouds = BIZZABO_CLOUDS.join('|');
const CLOUDINARY_UPLOAD_SOURCE =
    `(?:https?:)?\\/\\/(?:res\\.cloudinary\\.com\\/(${clouds})|(${clouds})-res\\.cloudinary\\.com)\\/image\\/upload\\/`;

const CLOUDINARY_IMAGE_UPLOAD = new RegExp(`^${CLOUDINARY_UPLOAD_SOURCE}`);
const CLOUDINARY_IMAGE_UPLOAD_IN_TEXT = new RegExp(`(?<![\\w.-])${CLOUDINARY_UPLOAD_SOURCE}`, 'g');

const toAssetsExtPrefix = (match, cloud, subdomainCloud) => `${ASSETS_EXT_ORIGIN}/${cloud || subdomainCloud}/image/upload/`;

export const toAssetsExtUrl = url => (typeof url === 'string' ? url.replace(CLOUDINARY_IMAGE_UPLOAD, toAssetsExtPrefix) : url);

export const rewriteAssetsExtUrlsInText = text =>
    typeof text === 'string' ? text.replace(CLOUDINARY_IMAGE_UPLOAD_IN_TEXT, toAssetsExtPrefix) : text;
